// Console filter utility for third-party warnings
// This module helps suppress known third-party console warnings that are not actionable

const initConsoleFilter = () => {
    // Only apply in development mode
    if (process.env.NODE_ENV !== 'development') {
        return;
    }

    const originalWarn = console.warn;
    const originalError = console.error;
    const originalLog = console.log;

    // Patterns for third-party warnings to suppress
    const suppressPatterns = [
        // Grammarly extension warnings
        /\[Violation\].*passive event listener/i,
        /Grammarly\.js/,

        // Google Sign-In warnings
        /Cross-Origin-Opener-Policy/,
        /accounts\.google\.com/,
        /BroadcastChannel/,

        // Other common third-party warnings
        /DevTools failed to load source map/,
        /Download the React DevTools/,

        // Browser extension warnings
        /Extension context/,
        /chrome-extension:/
    ];

    const shouldSuppress = (args) => {
        if (!args || !args.length) return false;

        // Convert first argument to string
        const message = String(args[0]);

        // Check if this is a third-party warning
        return suppressPatterns.some(pattern => pattern.test(message));
    };

    // Override console methods
    console.warn = function() {
        if (!shouldSuppress(arguments)) {
            originalWarn.apply(console, arguments);
        }
    };

    console.error = function() {
        if (!shouldSuppress(arguments)) {
            originalError.apply(console, arguments);
        }
    };

    // Optionally suppress verbose logs
    if (process.env.REACT_APP_SUPPRESS_VERBOSE_LOGS === 'true') {
        console.log = function() {
            if (!shouldSuppress(arguments)) {
                originalLog.apply(console, arguments);
            }
        };
    }

    // Log that filtering is active (using original console)
    originalLog('%c🔇 Third-party console warnings are being filtered', 'color: #888; font-style: italic;');
};

export default initConsoleFilter;